module.exports = __webpack_public_path__ + "img/icon_form_blue.ec4aaaa6.svg";